<ng-container wp-isolated-query-space class="op-wp-table-qs">
  <widget-wp-table [resource]="resource"
                   (resourceChanged)="onResourceChanged($event)"> </widget-wp-table>
</ng-container>
